// Re-Tech shop pages v2: collection quick filters UI glue, GPU compare, Halloween prices,
// GPU product block (FPS, trade-in, fit check, configurator link). Works with rt-shopping.js.
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const parse = el => { try { return JSON.parse(el?.textContent || 'null'); } catch { return null; } };
const store = {
  get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch { return null; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} }
};
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));

const shared = parse($('[data-rs2-shared]')) || {locale: 'bg', mode: 'preview', hw: null, games: {}};
const L = shared.locale === 'en' ? 'en' : 'bg';
const RES = ['1080p', '1440p', '4K'];
const AAA = ['warzone', 'cyberpunk-2077', 'rdr2', 'black-myth-wukong', 'cod-black-ops-6'];
const eur = n => (Math.round(n * 100) / 100).toLocaleString(L === 'en' ? 'en-IE' : 'bg-BG', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' €';

const C = {
  bg: {
    hw_card: 'с твоя код', hw_min: 'кодът важи от 400 €', hw_line: 'Хелоуин код {code}: {now} вместо {was}', hw_apply: 'Приложи кода',
    hint_res: 'Карти с поне 60 FPS средно в 5 AAA игри на {res} (Ultra/High, с DLSS/FSR където е нужно). Подредени по FPS за евро.',
    hint_ai: 'Карти с поне 12 GB видеопамет — за локални езикови модели от 14B нагоре. За 32B+ гледай 24 GB.',
    cmp_n: '{n} за сравнение', cmp_max: 'Сравняват се до 3 карти', cmp_price: 'Цена', cmp_vram: 'Видеопамет', cmp_avg: 'Средно в 5 AAA игри', cmp_res: 'Резолюция', cmp_view: 'Виж картата', cmp_remove: 'Махни', cmp_more: 'Избери още 1 карта за сравнение', cmp_value: 'FPS за 100 € · {res}', cmp_note: 'Средни FPS с бърз процесор. „FPS за 100 €“ = средните FPS в 5 AAA игри, разделени на цената — по-високото е по-изгодно.',
    mine_shop: 'Карти, които продаваме', mine_cat: 'Други модели',
    offer: 'Предварителна оферта', credit: 'Кредит за тази карта (+{b}%)', pay: 'Тази карта ти излиза', after_test: 'Окончателната цена потвърждаваме след тест. Без ангажимент.',
    take: 'Вземи офертата', rest: 'Кредитът покрива цялата карта — остават ти {n} за друга покупка при нас.', manual: 'Този модел оценяваме ръчно — изпрати детайлите и ще получиш оферта до 1 работен ден.', manual_high: 'Цените на този модел се движат бързо — оценяваме го ръчно в рамките на няколко часа.',
    vs: 'Спрямо твоята {m}: средно {d} FPS на {res}', vs_none: 'Нямаме FPS данни за {m} — сравнението не е налично.',
    fit_ok_len: 'Влиза — остават {n} mm.', fit_warn_len: 'Някои модели са до {len} mm. Ще изберем такъв, който влиза в {n} mm — напиши го в бележката към поръчката.', fit_bad_len: 'Не влиза: картата е {len} mm, а кутията побира {n} mm.',
    fit_ok_psu: 'Захранването стига.', fit_warn_psu: 'На ръба: препоръчваме {rec} W. С качествено 80+ Gold и процесор до 105 W обикновено работи.', fit_bad_psu: 'Нужно е по-мощно захранване — поне {rec} W.', fit_psu_link: 'Виж захранвания'
  },
  en: {
    hw_card: 'with your code', hw_min: 'code applies from 400 €', hw_line: 'Halloween code {code}: {now} instead of {was}', hw_apply: 'Apply the code',
    hint_res: 'Cards averaging 60+ FPS across 5 AAA games at {res} (Ultra/High, DLSS/FSR where needed). Sorted by FPS per euro.',
    hint_ai: 'Cards with 12 GB+ video memory — for local language models from 14B up. For 32B+ look at 24 GB.',
    cmp_n: '{n} to compare', cmp_max: 'Compare up to 3 cards', cmp_price: 'Price', cmp_vram: 'Video memory', cmp_avg: 'Average, 5 AAA games', cmp_res: 'Resolution', cmp_view: 'View card', cmp_remove: 'Remove', cmp_more: 'Pick 1 more card to compare', cmp_value: 'FPS per 100 € · {res}', cmp_note: 'Average FPS with a fast CPU. "FPS per 100 €" = average FPS across 5 AAA games divided by price — higher is better value.',
    mine_shop: 'Cards we sell', mine_cat: 'Other models',
    offer: 'Preliminary offer', credit: 'Credit towards this card (+{b}%)', pay: 'This card costs you', after_test: 'We confirm the final price after testing. No commitment.',
    take: 'Get the offer', rest: 'The credit covers the whole card — {n} stays with you for another purchase.', manual: 'We price this model by hand — send the details and you get a quote within 1 working day.', manual_high: 'Prices for this model move fast — we price it by hand within a few hours.',
    vs: 'Compared with your {m}: {d} FPS on average at {res}', vs_none: "We don't have FPS data for {m} — no comparison.",
    fit_ok_len: 'Fits — {n} mm to spare.', fit_warn_len: 'Some models are up to {len} mm. We\'ll pick one that fits in {n} mm — add it to the order note.', fit_bad_len: "Doesn't fit: the card is {len} mm, the case takes {n} mm.",
    fit_ok_psu: 'Your power supply is enough.', fit_warn_psu: 'Borderline: we recommend {rec} W. A good 80+ Gold unit with a CPU up to 105 W usually works.', fit_bad_psu: 'You need a stronger power supply — at least {rec} W.', fit_psu_link: 'See power supplies'
  }
}[L];
const fmt = (s, o) => s.replace(/\{(\w+)\}/g, (_, k) => o[k] ?? '');

// ---------- GA4 (consent-gated, live theme only) ----------
const GA = 'G-QR3RPVJ3M1';
const live = shared.mode === 'live';
const queue = [];
let gaReady = false;
const analyticsOk = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
function gaInit() {
  if (gaReady) return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
  if (!$('script[src*="googletagmanager.com/gtag/js"]')) {
    const sc = document.createElement('script'); sc.async = true; sc.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA; document.head.append(sc);
    window.gtag('js', new Date());
  }
  window.gtag('config', GA, {send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false});
  gaReady = true;
}
function flush() { if (!live || !queue.length || !analyticsOk()) return; gaInit(); while (queue.length) { const [n, p] = queue.shift(); window.gtag('event', n, p); } }
function track(name, params = {}) {
  const p = {...params, rs2_locale: L, send_to: GA};
  if (!live) { document.dispatchEvent(new CustomEvent('rs2:preview-event', {detail: {name, params: p}})); return; }
  queue.push([name, p]); flush();
}
document.addEventListener('visitorConsentCollected', flush);
window.addEventListener('pageshow', flush);

// ---------- Halloween ----------
function hwPick() {
  const hw = shared.hw; if (!hw) return null;
  if (Date.now() > Date.parse(hw.ends)) return null;
  const st = store.get(hw.key);
  if (!st || !st.code || !hw.tiers[st.k]) return null;
  return {code: st.code, k: st.k, tier: hw.tiers[st.k]};
}
function hwPrice(e, tier) {
  if (tier.t === 'pct') return Math.floor(e * (1 - tier.v / 100));
  if (tier.t === 'amt') return e >= (tier.min || 0) ? Math.floor(e - tier.v) : null;
  return null;
}
const hwOk = h => !!shared.hw && (shared.hw.handles || []).includes(h);
function hwCards(scope = document) {
  const pick = hwPick(); if (!pick) return;
  $$('[data-rts-card][data-handle]', scope).forEach(card => {
    if (card.dataset.rs2Hw || !hwOk(card.dataset.handle) || card.dataset.state === 'sold') return;
    const was = Number(card.dataset.price) / 100; if (!(was > 0)) return;
    const now = hwPrice(was, pick.tier);
    const box = $('.rts-card-price', card); if (!box) return;
    const el = document.createElement('p'); el.className = 'rs2-hwprice';
    el.innerHTML = now == null ? esc(C.hw_min) : '<b>' + esc(eur(now)) + '</b> ' + esc(C.hw_card);
    box.after(el); card.dataset.rs2Hw = '1';
  });
}
hwCards();
// cards inside <template data-rts-more> are moved into the grid by rt-shopping.js; tag them on every render
document.addEventListener('rts:render', e => hwCards(e.target), true);

// ---------- Collection: quick filter hint, FPS line resolution, compare ----------
const cat = $('[data-rts-catalog][data-rts-gpu]');
let syncCmp = () => {};
if (cat) {
  const hint = $('[data-rs2q-hint]', cat);
  let res = '1440p';
  const perfOf = card => { if (typeof window.rtsPerf === 'function') return window.rtsPerf(card); try { return JSON.parse(card.dataset.perf || 'null'); } catch { return null; } };
  function cardLines() {
    $$('[data-rts-card][data-gpu]', cat).forEach(card => {
      const line = $('[data-rs2-cardfps]', card), perf = perfOf(card); if (!line || !perf) return;
      const gh = ['cyberpunk-2077', 'warzone', 'rdr2', 'cod-black-ops-6'].find(g => perf.g?.[g]?.[res]);
      const v = gh && perf.g[gh][res];
      line.innerHTML = v ? '<b>~' + esc(v[0]) + ' FPS</b> <span>' + esc(shared.games?.[gh] || gh) + ' · ' + esc(res) + '</span>' : '';
    });
  }
  cat.addEventListener('rts:render', e => {
    const s = e.detail?.state || {};
    res = RES.includes(s.use) ? s.use : '1440p';
    if (hint) {
      hint.hidden = !s.use;
      hint.textContent = !s.use ? '' : s.use === 'ai' ? C.hint_ai : fmt(C.hint_res, {res: s.use});
    }
    cardLines();
    syncCmp();
  });
  { const u = new URL(location.href).searchParams.get('rt_use') || ''; res = RES.includes(u) ? u : '1440p'; if (hint && u) { hint.hidden = false; hint.textContent = u === 'ai' ? C.hint_ai : fmt(C.hint_res, {res: u}); } }
  queueMicrotask(() => { cardLines(); syncCmp(); });
  $$('[data-rts-quick]', cat).forEach(b => b.addEventListener('click', () => track('rs2_quick', {rs2_label: b.dataset.rtsQuick + ':' + b.dataset.value})));
  $('[data-rts-sort]', cat)?.addEventListener('change', e => { if (/^fps/.test(e.target.value)) track('rs2_sort', {rs2_label: e.target.value}); });

  // compare: selection is stored as a snapshot (survives paging, filtering and reloads)
  syncCmp = initCompare();
}

function initCompare() {
  const KEY = 'retech.rs2.cmp.v1';
  const host = $('[data-rts-catalog][data-rts-gpu]');
  let tray = host && $('[data-rs2c-tray]', host), dlg = host && $('[data-rs2c-dialog]', host);
  if (!tray || !dlg) return () => {};
  // move out of the section so no ancestor can clip or re-anchor the fixed bar / modal;
  // the wrapper carries .rt so the theme's colour/font variables still apply
  const portal = document.createElement('div');
  portal.className = 'rt rs2c-portal';
  document.body.append(portal);
  portal.append(tray, dlg);
  const short = t => String(t || '').replace(/^(NVIDIA\s+GeForce|AMD\s+Radeon)\s+/i, '');
  const body = $('[data-rs2c-body]', dlg);
  let chosen = (store.get(KEY) || []).filter(x => x && x.h && x.t).slice(0, 3);
  let cmpRes = '1440p';
  const perfOf = card => { if (typeof window.rtsPerf === 'function') return window.rtsPerf(card); try { return JSON.parse(card.dataset.perf || 'null'); } catch { return null; } };
  const snap = card => ({
    h: card.dataset.handle, t: card.dataset.title || $('.rts-card-title', card)?.textContent.trim() || card.dataset.handle,
    url: $('.rts-card-title a, a', card)?.getAttribute('href') || '#', price: Number(card.dataset.price) / 100,
    vram: Number(card.dataset.vram) || 0, perf: perfOf(card), img: ($('img', card)?.currentSrc || $('img', card)?.getAttribute('src') || '')
  });
  const save = () => store.set(KEY, chosen);
  function sync() {
    const hs = chosen.map(x => x.h);
    $$('[data-rs2-cmp]').forEach(i => { i.checked = hs.includes(i.value); i.disabled = !i.checked && chosen.length >= 3; });
    tray.hidden = chosen.length === 0;
    const names = $('[data-rs2c-names]', tray);
    if (names) names.innerHTML = chosen.map(x => '<span class="rs2c-pill"><span>' + esc(short(x.t)) + '</span><button type="button" data-rs2c-remove="' + esc(x.h) + '" aria-label="' + esc(C.cmp_remove) + ': ' + esc(x.t) + '">×</button></span>').join('');
    $('[data-rs2c-count]', tray).textContent = chosen.length < 2 ? C.cmp_more : fmt(C.cmp_n, {n: chosen.length}) + (chosen.length >= 3 ? ' · ' + C.cmp_max : '');
    const open = $('[data-rs2c-open]', tray); open.disabled = chosen.length < 2; open.setAttribute('aria-disabled', String(chosen.length < 2));
    document.documentElement.classList.toggle('rs2c-has-tray', chosen.length > 0);
  }
  function toggle(card, on) {
    const h = card?.dataset.handle; if (!h) return;
    if (on && !chosen.some(x => x.h === h) && chosen.length < 3) chosen.push(snap(card));
    if (!on) chosen = chosen.filter(x => x.h !== h);
    save(); sync();
  }
  document.addEventListener('change', e => {
    const i = e.target.closest?.('[data-rs2-cmp]'); if (!i) return;
    toggle(i.closest('[data-rts-card]'), i.checked);
  });
  tray.addEventListener('click', e => {
    const rm = e.target.closest('[data-rs2c-remove]');
    if (rm) { chosen = chosen.filter(x => x.h !== rm.dataset.rs2cRemove); save(); sync(); return; }
    if (e.target.closest('[data-rs2c-clear]')) { chosen = []; save(); sync(); return; }
    if (e.target.closest('[data-rs2c-open]') && chosen.length >= 2) openCmp();
  });
  function renderCmp() {
    const list = chosen;
    const avg = p => { const v = AAA.map(g => p?.g?.[g]?.[cmpRes]?.[0]).filter(n => n > 0); return v.length ? Math.round(v.reduce((a, b) => a + b, 0) / v.length) : null; };
    const games = Object.keys(shared.games || {});
    const row = (label, vals, fmtv, hi = 'max', cls = '') => {
      const nums = vals.filter(v => v != null);
      let top = nums.length > 1 ? (hi === 'min' ? Math.min(...nums) : Math.max(...nums)) : null;
      if (top != null && nums.filter(v => v === top).length > 1) top = null; // ties: highlight nothing
      return '<tr class="' + cls + '"><th scope="row">' + esc(label) + '</th>' + vals.map(v => '<td' + (v != null && v === top ? ' class="is-best"' : '') + '>' + (v == null ? '—' : esc(fmtv(v))) + '</td>').join('') + '</tr>';
    };
    const avgs = list.map(x => avg(x.perf));
    body.innerHTML =
      '<div class="rg2-seg" role="group" aria-label="' + esc(C.cmp_res) + '">' + RES.map(r => '<button type="button" data-rs2c-res="' + r + '" aria-pressed="' + (r === cmpRes) + '">' + r + '</button>').join('') + '</div>' +
      '<div class="rs2c-scroll"><table class="rs2c-table"><thead><tr><td></td>' + list.map(x => '<th scope="col"><a href="' + esc(x.url) + '">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '<span>' + esc(x.t) + '</span></a></th>').join('') + '</tr></thead><tbody>' +
      row(C.cmp_price, list.map(x => x.price || null), eur, 'min', 'rs2c-key') +
      row(C.cmp_avg + ' · ' + cmpRes, avgs, v => '~' + v + ' FPS', 'max', 'rs2c-key') +
      row(fmt(C.cmp_value, {res: cmpRes}), list.map((x, i) => avgs[i] && x.price ? Math.round(avgs[i] / x.price * 1000) / 10 : null), v => v.toLocaleString(L === 'en' ? 'en-IE' : 'bg-BG') + ' FPS', 'max', 'rs2c-key') +
      row(C.cmp_vram, list.map(x => x.vram || null), v => v + ' GB') +
      games.map(g => row(shared.games[g], list.map(x => x.perf?.g?.[g]?.[cmpRes]?.[0] ?? null), v => v + ' FPS')).join('') +
      '<tr class="rs2c-actions"><td></td>' + list.map(x => '<td><a class="rts-button" href="' + esc(x.url) + '" data-rs2c-view="' + esc(x.h) + '">' + esc(C.cmp_view) + ' →</a><button type="button" class="rts-text-link" data-rs2c-drop="' + esc(x.h) + '">' + esc(C.cmp_remove) + '</button></td>').join('') + '</tr>' +
      '</tbody></table></div><p class="rs2c-note">' + esc(C.cmp_note) + '</p>';
  }
  body.addEventListener('click', e => {
    const r = e.target.closest('[data-rs2c-res]'); if (r) { cmpRes = r.dataset.rs2cRes; renderCmp(); return; }
    const d = e.target.closest('[data-rs2c-drop]');
    if (d) { chosen = chosen.filter(x => x.h !== d.dataset.rs2cDrop); save(); sync(); if (chosen.length < 2) closeCmp(); else renderCmp(); return; }
    const v = e.target.closest('[data-rs2c-view]'); if (v) track('rs2_compare_view', {rs2_label: v.dataset.rs2cView});
  });
  function openCmp() {
    const u = new URL(location.href).searchParams.get('rt_use') || '';
    cmpRes = RES.includes(u) ? u : '1440p';
    renderCmp();
    if (typeof dlg.showModal === 'function') { try { dlg.showModal(); } catch { dlg.setAttribute('open', ''); } } else dlg.setAttribute('open', '');
    document.documentElement.classList.add('rts-modal-open');
    track('rs2_compare', {rs2_label: chosen.map(x => x.h).join('|')});
  }
  function closeCmp() { if (dlg.open) { try { dlg.close(); } catch { dlg.removeAttribute('open'); } } document.documentElement.classList.remove('rts-modal-open'); }
  $('[data-rs2c-close]', dlg)?.addEventListener('click', closeCmp);
  dlg.addEventListener('click', e => { if (e.target === dlg) closeCmp(); });
  dlg.addEventListener('close', () => document.documentElement.classList.remove('rts-modal-open'));
  // refresh stored snapshots with current data when the card is on this page
  chosen = chosen.map(x => { const c = $('[data-rts-card][data-handle="' + (window.CSS?.escape ? CSS.escape(x.h) : x.h) + '"]'); return c ? snap(c) : x; });
  save(); sync();
  return sync;
}

// ---------- Product page ----------
const prod = $('[data-rts-product]');
if (prod) {
  const variants = parse($('[data-rts-variants]', prod)) || [];
  const curCents = () => {
    const id = $('form[data-rts-add] [name=id]', prod)?.value;
    const v = variants.find(x => String(x.id) === String(id)) || [...variants].sort((a, b) => a.cents - b.cents)[0];
    return v ? {cents: v.cents, id: v.id, state: v.state, selected: !!id} : null;
  };
  // Halloween line
  const hwEl = $('[data-rs2-hw]', prod);
  function hwLine() {
    if (!hwEl) return;
    const pick = hwPick(), cur = curCents();
    if (!pick || !cur || !hwOk(prod.dataset.handle) || cur.state === 'sold' || cur.state === 'enquiry') { hwEl.hidden = true; return; }
    const was = cur.cents / 100, now = hwPrice(was, pick.tier);
    if (now == null) { hwEl.hidden = false; hwEl.textContent = C.hw_min; return; }
    let path = location.pathname; try { path = decodeURI(path); } catch {}
    const href = ((window.Shopify?.routes?.root) || '/') + 'discount/' + encodeURIComponent(pick.code) + '?redirect=' + encodeURIComponent(path + location.search);
    hwEl.innerHTML = '<span>' + esc(fmt(C.hw_line, {code: pick.code, now: eur(now), was: eur(was)})) + '</span> <a href="' + esc(href) + '" data-rs2-hw-apply>' + esc(C.hw_apply) + ' →</a>';
    hwEl.hidden = false;
  }
  hwEl?.addEventListener('click', e => { if (e.target.closest('[data-rs2-hw-apply]')) track('rs2_hw_apply', {rs2_label: hwPick()?.k || ''}); });

  $('[data-rs2-viber]', prod)?.addEventListener('click', () => track('rs2_viber', {rs2_label: prod.dataset.handle}));
  $('[data-rs2-alt]', prod)?.addEventListener('click', () => track('rs2_alt_click', {rs2_label: prod.dataset.handle}));

  const box = $('[data-rg2]', prod);
  const data = box ? parse($('[data-rg2-data]', box)) : null;
  let onPrice = () => {};

  if (box && data) {
    const self = data.self;
    const gpus = (data.gpus || []).filter(Boolean);
    const sell = data.sell;
    const r5 = v => Math.max(5, Math.round(v / 5) * 5);
    // trade-in models: shop cards, then catalogue models not already covered
    const norm = t => String(t || '').toLowerCase().replace(/nvidia|geforce|amd|radeon|\(.*?\)/g, '').replace(/[^a-z0-9]+/g, '');
    const models = [];
    gpus.forEach(g => models.push({id: 'g:' + g.h, label: g.t, S: g.S, M: g.M, ageH: null, perf: g.perf, vram: g.vram}));
    const now = (data.now || Date.now() / 1000) * 1000;
    (data.catalogue?.models || []).forEach(c => {
      if (!c.title || models.some(m => norm(m.label) === norm(c.title))) return;
      const age = c.observedAt ? (now - Date.parse(c.observedAt)) / 3.6e6 : 1e9;
      models.push({id: 'c:' + c.id, label: c.title, S: 0, M: Number(c.marketPriceEur) || 0, ageH: age < 0 ? 1e9 : age, locked: c.manualLock === true, perf: null, vram: c.vramGb, cat: true});
    });
    function offerFor(m, cond) {
      const mul = sell.cond[cond]; if (!m || !mul) return {kind: 'manual'};
      let a;
      if (m.S > 0) {
        if (m.S < sell.minResale) return {kind: 'manual'};
        const N = Math.max(sell.profitFloor, sell.profitPct * m.S);
        const formula = m.S - sell.vatFactor * (N + sell.refurb + sell.warrantyPct * m.S + sell.handling);
        a = m.M > 0 ? Math.min(formula, sell.marketCap * m.M) : formula;
      } else if (m.M > 0 && (m.locked || m.ageH <= sell.staleHours)) {
        a = sell.catalogueRatio * m.M;
      } else return {kind: 'manual'};
      if (!(a > 0)) return {kind: 'manual'};
      if (a > sell.maxAuto) return {kind: 'manual', high: true};
      const high = r5(a * mul);
      return {kind: 'offer', low: r5(a * mul * sell.rangeLow), high, credit: r5(high * (1 + sell.tradeBonus))};
    }

    // resolution + FPS tables
    let res = store.get('retech.rs2.res') || box.dataset.res || '1440p';
    if (!RES.includes(res)) res = '1440p';
    function setRes(r, user) {
      res = r;
      $$('[data-rg2-res]', box).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.rg2Res === r)));
      $$('[data-rg2-table]', box).forEach(t => { t.hidden = t.dataset.rg2Table !== r; });
      if (user) { store.set('retech.rs2.res', r); track('rs2_fps_res', {rs2_label: r}); }
      compareFps();
    }
    $$('[data-rg2-res]', box).forEach(b => b.addEventListener('click', () => setRes(b.dataset.rg2Res, true)));

    // trade-in UI
    const sel = $('[data-rg2-mine]', box), out = $('[data-rg2-trade-out]', box);
    const shopModels = models.filter(m => !m.cat), catModels = models.filter(m => m.cat);
    const og = (label, list) => '<optgroup label="' + esc(label) + '">' + list.map(m => '<option value="' + esc(m.id) + '">' + esc(m.label) + '</option>').join('') + '</optgroup>';
    sel.insertAdjacentHTML('beforeend', og(C.mine_shop, shopModels) + (catModels.length ? og(C.mine_cat, catModels) : ''));
    const saved = store.get('retech.rs2.mine') || {};
    let cond = ['a', 'b', 'c'].includes(saved.cond) ? saved.cond : 'b';
    if (saved.id && models.some(m => m.id === saved.id)) sel.value = saved.id;
    const mine = () => models.find(m => m.id === sel.value) || null;
    function setCond(c) { cond = c; $$('[data-rg2-cond]', box).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.rg2Cond === c))); }
    setCond(cond);
    function trade(user) {
      const m = mine(), cur = curCents();
      store.set('retech.rs2.mine', {id: sel.value, cond});
      const o = m ? offerFor(m, cond) : null, price = cur ? cur.cents / 100 : self.S;
      const bl = $('[data-rg2-build]', box);
      if (bl) {
        const [base, hash] = bl.getAttribute('href').split('#'); const q = new URLSearchParams(hash || '');
        if (m) q.set('trade', m.label + ', ' + ({a: L === 'en' ? 'like new' : 'като нова', b: L === 'en' ? 'good' : 'добра', c: L === 'en' ? 'cosmetic issues' : 'със забележки'})[cond] + (o?.kind === 'offer' ? ' — ' + (L === 'en' ? 'website offer' : 'оферта от сайта') + ' ' + o.low + '–' + o.high + ' €' : ''));
        else q.delete('trade');
        bl.setAttribute('href', base + '#' + q.toString());
      }
      if (!m) { out.innerHTML = ''; compareFps(); return; }
      const sellLink = data.sellUrl + '?upgrade=' + encodeURIComponent(self.t);
      if (o.kind !== 'offer') {
        out.innerHTML = '<p class="rg2-manual">' + esc(o.high ? C.manual_high : C.manual) + '</p><a class="rts-button rts-button-secondary" href="' + esc(sellLink) + '" data-rg2-take>' + esc(C.take) + ' →</a>';
      } else {
        const pay = Math.max(0, price - o.credit), rest = Math.max(0, o.credit - price);
        out.innerHTML =
          '<dl class="rg2-offer"><div><dt>' + esc(C.offer) + '</dt><dd>' + esc(o.low) + '–' + esc(eur(o.high)) + '</dd></div>' +
          '<div><dt>' + esc(fmt(C.credit, {b: Math.round(sell.tradeBonus * 100)})) + '</dt><dd>−' + esc(eur(o.credit)) + '</dd></div>' +
          '<div class="rg2-pay"><dt>' + esc(C.pay) + '</dt><dd>' + esc(eur(pay)) + '</dd></div></dl>' +
          (rest > 0 ? '<p class="rg2-note rg2-rest">' + esc(fmt(C.rest, {n: eur(rest)})) + '</p>' : '') +
          '<p class="rg2-note">' + esc(C.after_test) + '</p>' +
          '<a class="rts-button" href="' + esc(sellLink) + '" data-rg2-take>' + esc(C.take) + ' →</a>';
        if (user) track('rs2_trade_offer', {rs2_label: m.label + ' · ' + cond, value: o.credit, currency: 'EUR'});
      }
      compareFps();
    }
    sel.addEventListener('change', () => { trade(true); if (sel.value) track('rs2_mine', {rs2_label: mine()?.label || ''}); });
    $$('[data-rg2-cond]', box).forEach(b => b.addEventListener('click', () => { setCond(b.dataset.rg2Cond); trade(true); }));
    out.addEventListener('click', e => { if (e.target.closest('[data-rg2-take]')) track('rs2_trade_take', {rs2_label: mine()?.label || ''}); });

    // FPS delta vs the visitor's card
    function compareFps() {
      const line = $('[data-rg2-compare-line]', box); const m = mine();
      const rows = $$('[data-rg2-table] li[data-game]', box);
      rows.forEach(li => { const d = $('[data-rg2-delta]', li); if (d) { d.hidden = true; d.textContent = ''; d.className = ''; } });
      if (!line) return;
      if (!m) { line.hidden = true; return; }
      if (!m.perf) { line.hidden = false; line.className = 'rg2-compare is-none'; line.textContent = fmt(C.vs_none, {m: m.label}); return; }
      const ratios = [];
      rows.forEach(li => {
        const r = li.closest('[data-rg2-table]').dataset.rg2Table;
        const theirs = m.perf.g?.[li.dataset.game]?.[r]?.[0], ours = Number(li.dataset.fps);
        if (!(theirs > 0) || !(ours > 0)) return;
        const pct = Math.round((ours / theirs - 1) * 100);
        const d = $('[data-rg2-delta]', li); d.hidden = false; d.textContent = (pct > 0 ? '+' : '') + pct + '%'; d.className = pct >= 0 ? 'is-up' : 'is-down';
        if (r === res && AAA.includes(li.dataset.game)) ratios.push(ours / theirs);
      });
      if (!ratios.length) { line.hidden = true; return; }
      const avg = Math.round((ratios.reduce((a, b) => a + b, 0) / ratios.length - 1) * 100);
      line.hidden = false; line.className = 'rg2-compare ' + (avg >= 0 ? 'is-up' : 'is-down');
      line.textContent = fmt(C.vs, {m: m.label, d: (avg > 0 ? '+' : '') + avg + '%', res});
    }

    // fit check
    const fit = $('[data-rg2-fit]', box), fitOut = $('[data-rg2-fit-out]', box);
    if (fit && fitOut) {
      const len = Number(fit.dataset.len) || 0, rec = Number(fit.dataset.psu) || 0, exact = fit.dataset.exact === 'true';
      const caseIn = $('[data-rg2-case]', fit), psuIn = $('[data-rg2-psu]', fit);
      const fs = store.get('retech.rs2.fit') || {};
      if (caseIn && fs.c) caseIn.value = fs.c;
      if (psuIn && fs.p) psuIn.value = fs.p;
      let sent = '';
      function check(user) {
        const c = Number(caseIn?.value) || 0, p = Number(psuIn?.value) || 0, msgs = [];
        store.set('retech.rs2.fit', {c: c || '', p: p || ''});
        let worst = '';
        const rank = {ok: 0, warn: 1, bad: 2}, bump = s => { if (!worst || rank[s] > rank[worst]) worst = s; };
        if (len && c >= 100) {
          if (len <= c) { msgs.push(['ok', fmt(C.fit_ok_len, {n: c - len})]); bump('ok'); }
          else if (!exact && c >= 240) { msgs.push(['warn', fmt(C.fit_warn_len, {len, n: c})]); bump('warn'); }
          else { msgs.push(['bad', fmt(C.fit_bad_len, {len, n: c})]); bump('bad'); }
        }
        if (rec && p >= 200) {
          if (p >= rec) { msgs.push(['ok', C.fit_ok_psu]); bump('ok'); }
          else if (p >= rec - 100) { msgs.push(['warn', fmt(C.fit_warn_psu, {rec})]); bump('warn'); }
          else { msgs.push(['bad', fmt(C.fit_bad_psu, {rec}), ((window.Shopify?.routes?.root) || '/') + 'collections/захранвания']); bump('bad'); }
        }
        fitOut.innerHTML = msgs.map(([s, t, link]) => '<p class="rg2-v rg2-v--' + s + '">' + esc(t) + (link ? ' <a href="' + esc(link) + '">' + esc(C.fit_psu_link) + ' →</a>' : '') + '</p>').join('');
        if (user && worst && worst !== sent) { sent = worst; track('rs2_fit', {rs2_label: worst}); }
      }
      let t;
      [caseIn, psuIn].filter(Boolean).forEach(i => i.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => check(true), 500); }));
      check(false);
    }

    // configurator link follows the chosen variant (only when this product is the configurator part)
    const build = $('[data-rg2-build]', box);
    build?.addEventListener('click', () => track('rs2_build_click', {rs2_label: self.h}));
    onPrice = () => {
      if (build && self.dh === self.h) {
        const cur = curCents(); const u = build.getAttribute('href').split('#');
        const q = new URLSearchParams(u[1] || ''); if (cur?.selected) q.set('gv', cur.id); build.setAttribute('href', u[0] + '#' + q.toString());
      }
      if (sel.value) trade(false);
    };

    setRes(res, false);
    trade(false);
  }

  const priceEl = $('[data-rts-price]', prod);
  if (priceEl) new MutationObserver(() => { hwLine(); onPrice(); }).observe(priceEl, {childList: true, characterData: true, subtree: true});
  hwLine();
}
